import React from 'react';
import { useTranslation } from 'react-i18next';
import { HorizontalBarChart } from '@fluentui/react-charting';
import './HorizontalBarFluentWidget.css';

const HorizontalBarFluentWidget = ({ data, config }) => {
    const { t } = useTranslation();

    console.log('📊 HorizontalBarFluentWidget received:', { data, config });

    // Extract configuration
    const xAxisKey = config?.config?.xAxisKey || config?.xAxisKey || 'value';
    const yAxisKey = config?.config?.yAxisKey || config?.yAxisKey || 'category';
    const thresholds = config?.config?.thresholds || config?.thresholds || {};

    // Ensure data is an array
    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div className="horizontal-bar-fluent-empty">
                <p>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    // Transform data for Fluent UI HorizontalBarChart
    // Format attendu: array d'objets avec chartTitle et chartData
    const fluentChartData = chartData.map((item, index) => {
        const categoryName = item[yAxisKey] || `Category ${index + 1}`;
        const value = item[xAxisKey] || 0;
        
        return {
            chartTitle: categoryName,
            chartData: [
                {
                    legend: categoryName,
                    horizontalBarChartdata: {
                        x: value,
                        y: value
                    },
                    color: getBarColorByCategory(categoryName, thresholds)
                }
            ]
        };
    });

    // Function to determine bar color based on category and thresholds
    function getBarColorByCategory(category, thresholds) {
        const categoryLower = (category || '').toLowerCase();
        
        if (categoryLower.includes('quick drop') || categoryLower.includes('quick_drop')) {
            return '#D13438'; // Red
        } else if (categoryLower.includes('quick answer') || categoryLower.includes('quick_answer')) {
            return '#107C10'; // Green
        } else if (categoryLower.includes('standard')) {
            return '#FFB900'; // Yellow
        } else if (categoryLower.includes('delayed')) {
            return '#E74856'; // Dark Red
        }
        
        return '#0078D4'; // Default blue
    }

    return (
        <div className="horizontal-bar-fluent-widget">
            <HorizontalBarChart
                data={fluentChartData}
                width="100%"
                height={280}
                barHeight={40}
                hideLegend={true}
                hideTooltip={false}
                enableReflow={true}
            />
            <div className="threshold-legend">
                <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: '#107C10' }}></span>
                    <span>{t('QUICK_ANSWER')}</span>
                </div>
                <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: '#FFB900' }}></span>
                    <span>{t('STANDARD_ANSWER')}</span>
                </div>
                <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: '#E74856' }}></span>
                    <span>{t('DELAYED_ANSWER')}</span>
                </div>
                <div className="legend-item">
                    <span className="legend-color" style={{ backgroundColor: '#D13438' }}></span>
                    <span>{t('QUICK_DROP')}</span>
                </div>
            </div>
        </div>
    );
};

export default HorizontalBarFluentWidget;
